module.exports = __webpack_public_path__ + "static/media/RecomendaPortodegalinhas.b1123425.jpg";